import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { FeaturesCount } from './FeaturesCount';

export class FeaturesFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [FeaturesCount];
  }

  get title() {
    return terminology('Features');
  }
}
